import { payHistoryActions, selectPayHistory } from "Features/pay_history";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

export const dataController = () => {
	const dispatch = useDispatch();
	const rawData = useSelector(selectPayHistory.list);
	const [renderArr, setRenderArr] = useState([]);
	useEffect(() => {
		dispatch(payHistoryActions.get());

		return () => {
			dispatch(payHistoryActions.drop());
		};
	}, []);

	function transformData(dataArr) {
		const response = [];
		dataArr.forEach((data) => {
			const isIban = !!data?.request?.iban_id;
			const isPaypal = !!data?.request?.paypal_id;
			let operation = "";
			if (data.operation_type === "IN") operation = "in";
			if (data.operation_type === "OUT") {
				if (isIban) operation = "out_iban";
				if (isPaypal) operation = "out_paypal";
				if (!isIban && !isPaypal) operation = "out_admin";
			}
			response.push({
				operation,
				date: data.created_at,
				amount: data.request?.net_amount ?? data.amount,
				comment: data.comment,
				id: data.id,
				operation_context: data.operation_context,
			});
			if (data.request?.tax_amount > 0) {
				response.push({
					operation: "out_tax",
					date: data.created_at,
					amount: data.request?.tax_amount,
					comment: "Income tax",
					id: data.id + "tax",
					operation_context: data.operation_context,
				});
			}
		});
		return response;
	}

	useEffect(() => {
		setRenderArr(transformData(rawData));
	}, [rawData]);

	return renderArr;
};
